/**
 * Appends standard UTM tags for outbound traffic.
 *
 * @param {string} url - The original URL
 * @returns {string} - The URL with UTM tags appended
 */
export const appendUtmTags = (url) => {
  if (!url) return url;
  try {
    const urlObj = new URL(url);
    if (!urlObj.searchParams.has("utm_source")) {
      urlObj.searchParams.set("utm_source", "handpik");
    }
    if (!urlObj.searchParams.has("utm_medium")) {
      urlObj.searchParams.set("utm_medium", "affiliate");
    }
    return urlObj.toString();
  } catch (e) {
    // If URL parsing fails (e.g. invalid URL format), return original
    return url;
  }
};
